import { render, staticRenderFns } from "./SingleUpdateTypeStatusChip.vue?vue&type=template&id=f739aaae&"
import script from "./SingleUpdateTypeStatusChip.vue?vue&type=script&lang=ts&"
export * from "./SingleUpdateTypeStatusChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VTooltip})
